import React from 'react';

const PAYHERE_LOGO = '/images/payhere_brand-1024x341.png';
const KOKO_LOGO = '/images/koko_brand-1024x341.png';

/**
 * PaymentBadges Component
 * Displays the PayHere and Koko Pay partner logos in a single row
 *
 * @param {string} className - Additional CSS classes
 */
const PaymentBadges = ({ className = '' }) => (
  <div className={`flex flex-row items-center gap-4 flex-nowrap ${className}`}>
    <img
      src={PAYHERE_LOGO}
      alt="PayHere logo"
      className="h-12 w-auto object-contain"
      loading="lazy"
    />
    {/* <img
      src={KOKO_LOGO}
      alt="Koko Pay logo"
      className="h-12 w-auto object-contain"
      loading="lazy"
    /> */}
  </div>
);

export const PaymentBadgesDetailed = ({ variant = 'light', className = '' }) => {
  const isLight = variant === 'light';

  return (
    <div className={`space-y-3 ${className}`}>
      {/* Heading */}
      <p className={`text-sm font-semibold ${isLight ? 'text-gray-900' : 'text-white'}`}>
        Flexible Payment Options
      </p>

      {/* PayHere Section */}
      <div className={`p-4 rounded-xl border ${isLight ? 'bg-white border-gray-200' : 'bg-white/5 border-white/10'
        }`}>
        <div className="flex items-center gap-2 mb-2">
          <img
            src={PAYHERE_LOGO}
            alt="PayHere logo"
            className="h-16 w-auto object-contain"
            loading="lazy"
          />
        </div>
        <p className={`text-xs ${isLight ? 'text-gray-600' : 'text-white/70'} mb-2`}>
          Instant payment with any debit/credit card or banking app
        </p>
        <div className="flex flex-wrap gap-1.5">
          <span className={`text-xs px-2 py-1 rounded ${isLight ? 'bg-gray-100 text-gray-700' : 'bg-white/10 text-white/90'}`}>
            Visa/Master
          </span>
          <span className={`text-xs px-2 py-1 rounded ${isLight ? 'bg-gray-100 text-gray-700' : 'bg-white/10 text-white/90'}`}>
            HNB/BOC/Sampath
          </span>
          <span className={`text-xs px-2 py-1 rounded ${isLight ? 'bg-gray-100 text-gray-700' : 'bg-white/10 text-white/90'}`}>
            Frimi
          </span>
          <span className={`text-xs px-2 py-1 rounded ${isLight ? 'bg-gray-100 text-gray-700' : 'bg-white/10 text-white/90'}`}>
            iPay
          </span>
        </div>
      </div>

      {/* Koko Pay Section */}
      <div className={`p-4 rounded-xl border ${isLight ? 'bg-white border-gray-200' : 'bg-white/5 border-white/10'
        }`}>
        <div className="flex items-center gap-2 mb-2">
          <img
            src={KOKO_LOGO}
            alt="Koko Pay logo"
            className="h-16 w-auto object-contain"
            loading="lazy"
          />
          <span className={`text-xs px-2 py-0.5 rounded-full ${isLight ? 'bg-emerald-100 text-emerald-700' : 'bg-emerald-500/20 text-emerald-300'}`}>
            0% Interest
          </span>
        </div>
        <p className={`text-xs ${isLight ? 'text-gray-600' : 'text-white/70'}`}>
          Split your payment into 3 interest-free installments
        </p>
      </div>
    </div>
  );
};

export default PaymentBadges;
